module.exports = global["application_chart_time"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./time.ts");